import log from 'salvo-lite/log'

class HoverPoints {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._hoverPoints = this._elem.querySelectorAll('[data-point]')
        this._innerElems = this._elem.querySelectorAll('[data-inner]')
        this.lastScrollY = 0
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        for (let hoverPoint of this._hoverPoints) {
            hoverPoint.addEventListener('mouseenter', e => {
                for (let inner of this._innerElems) {
                    inner.classList.remove('active')
                }
                this._elem.querySelector(`[data-inner='${hoverPoint.dataset.point}']`).classList.add('active')
            })
            hoverPoint.addEventListener('mouseleave', e => {
                for (let inner of this._innerElems) {
                    inner.classList.remove('active')
                }
                this._elem.querySelector(`[data-inner]`).classList.add('active')
            })
        }

        log.debug(this.constructor.name, 'Initiated')
    }
}

export default HoverPoints



// WEBPACK FOOTER //
// ./src/resources/scripts/components/HoverPoints.js